"use strict"

import angular from "angular"

import uiRouter from "angular-ui-router"

import routing from "./account.routes"
import login from "./login"
import settings from "./settings"
import signup from "./signup"
import oauthButtons from "../components/oauth-buttons"

function account($rootScope) {
  "ngInject"

  $rootScope.$on("$stateChangeStart", function (event, next, nextParams, current) {
    if (next.name === "logout" && current && current.name && !current.authenticate) {
      next.referrer = current.name
    }
  })
}

export default angular
  .module("makeamapAngularApp.account", [uiRouter, login, settings, signup, oauthButtons])
  .config(routing)
  .run(account).name
